// type-only import: ClassPassPage 가 이 파일의 값을 import 하므로 런타임 순환을 만들지 않는다.
import type { SortType } from './ClassPassPage';

/**
 * 수강권 관리 목록의 필터/정렬 옵션.
 * localStorage 키(`firstSortType`, `secondSortType`)와 `{ value, label }` 저장 형식은 기존 계약이라 유지한다.
 */
export const FIRST_SORT_OPTIONS: SortType[] = [
    { value: 'ENTIRE', label: '전체 보기' },
    { value: 'ACTIVE', label: '활성중' },
    { value: 'INACTIVE', label: '비활성중' },
];

// CUSTOM = 서버가 내려준 순서 그대로(관리자가 「순서 변경」으로 지정한 표시 순서). 기본값.
// 라벨은 RoundedDropDown(small, 136px) 안에 들어가야 하므로 기존 옵션과 비슷한 길이로 둔다.
export const CUSTOM_SORT_TYPE: SortType = { value: 'CUSTOM', label: '직접 설정 순' };

export const SECOND_SORT_OPTIONS: SortType[] = [
    CUSTOM_SORT_TYPE,
    { value: 'RECENT', label: '최근 생성 순' },
    { value: 'ACTIVE', label: '최근 사용 순' },
    { value: 'OLD', label: '오래된 생성 순' },
    { value: 'ALPHABET', label: '이름 가나다 순' },
];

export const DEFAULT_FIRST_SORT_TYPE: SortType = FIRST_SORT_OPTIONS[1]; // 활성중
export const DEFAULT_SECOND_SORT_TYPE: SortType = CUSTOM_SORT_TYPE;

/**
 * localStorage 에 저장된 정렬 옵션을 읽는다.
 * - 손상된 JSON, 예전 초기화 버그가 남긴 `false`, 사라진 옵션 값은 전부 기본값으로 돌린다.
 * - 라벨은 저장값이 아니라 현재 옵션 목록의 것을 쓴다(라벨 문구를 바꿔도 화면이 따라오게).
 */
export const readStoredSortType = (raw: string | null | undefined, options: SortType[], fallback: SortType): SortType => {
    if (!raw) return fallback;
    try {
        const parsed = JSON.parse(raw);
        const value = parsed && typeof parsed === 'object' ? parsed.value : undefined;
        if (typeof value !== 'string') return fallback;
        return options.find((option) => option.value === value) ?? fallback;
    } catch (_error) {
        return fallback;
    }
};
